import { RetailerNetworkUpdate, RetailerNetworkUpdateMutationOptions } from '@occc/graphql';

export enum RetailerNetworkConfigurationTabs {
  Details = 'details',
  Locations = 'locations',
  Users = 'users',
}

export type RetailerNetworkUpdateHandler = (
  input: Omit<RetailerNetworkUpdate, 'uuid'>,
  refetchQueries?: RetailerNetworkUpdateMutationOptions['refetchQueries'],
) => Promise<void>;
